import React, { useState } from "react";
import {
  Tooltip,
  Popover,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { TOOLTIP_COPY } from "./tooltipCopy";

const useStyles = makeStyles(() => ({
  infoIcon: {
    fontSize: "14px",
    color: "#BDBDBD",
    marginLeft: "4px",
    cursor: "pointer",
    verticalAlign: "middle",
    transform: "translateY(-1px)",
    "&:hover": {
      color: "#757575",
    },
  },
  tooltip: {
    backgroundColor: "#ffffff",
    color: "#333333",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
    fontSize: "12px",
    lineHeight: "1.5",
    padding: "10px 14px",
    maxWidth: 280,
    borderRadius: "6px",
    border: "1px solid #e0e0e0",
  },
  arrow: {
    color: "#ffffff",
    "&::before": {
      border: "1px solid #e0e0e0",
      backgroundColor: "#ffffff",
    },
  },
  popoverPaper: {
    backgroundColor: "#ffffff",
    color: "#333333",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
    fontSize: "12px",
    lineHeight: "1.5",
    padding: "10px 14px",
    maxWidth: 280,
    borderRadius: "6px",
    border: "1px solid #e0e0e0",
  },
}));

const TooltipIcon = ({ copyKey, title, placement = "right" }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);

  const tooltipText = title || TOOLTIP_COPY?.[copyKey];

  if (!tooltipText) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  // 📱 Mobile → Popover
  if (isMobile) {
    return (
      <>
        <InfoOutlinedIcon
          className={classes.infoIcon}
          onClick={handleClick}
        />

        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          getContentAnchorEl={null}
          marginThreshold={8}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          classes={{ paper: classes.popoverPaper }}
          PopperProps={{
            modifiers: {
              offset: {
                enabled: true,
                offset: "0, 8",
              },
              flip: {
                enabled: true,
                behavior: ["right", "left", "top", "bottom"],
              },
              preventOverflow: {
                enabled: true,
                boundariesElement: "viewport",
              },
            },
          }}
        >
          {tooltipText}
        </Popover>
      </>
    );
  }

  // 💻 Desktop → Tooltip
  return (
    <Tooltip
      title={tooltipText}
      placement={placement}
      interactive
      arrow
      enterDelay={200}
      enterNextDelay={200}
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
      PopperProps={{
        modifiers: {
          flip: {
            enabled: true,
            behavior: ["right", "left", "top", "bottom"],
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: "viewport",
          },
        },
      }}
    >
      <span>
        <InfoOutlinedIcon className={classes.infoIcon} />
      </span>
    </Tooltip>
  );
};

export default TooltipIcon;